import { Table } from '@shinetools/lumen-react'
import type { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import type { ExpertBalanceSheetColumnDef } from '../../../../hooks/useExpertBalanceSheetColumns'
import type { ExpertBalanceSheetTableRow } from '../../../../types/expertBalanceSheetView'
import * as Styled from '../../styles'
import { ExpertBalanceSheetTableBody } from '../ExpertBalanceSheetTableBody'
import { ExpertBalanceSheetTableHeader } from '../ExpertBalanceSheetTableHeader'

interface ExpertBalanceSheetTableContentProps<Row extends ExpertBalanceSheetTableRow> {
  columns: ExpertBalanceSheetColumnDef<Row>[]
  rows: Row[]
  isLoading: boolean
  isEmpty: boolean
  isError: boolean
}

export const ExpertBalanceSheetTableContent = <Row extends ExpertBalanceSheetTableRow>({
  columns,
  rows,
  isLoading,
  isEmpty,
  isError,
}: ExpertBalanceSheetTableContentProps<Row>): ReactElement => {
  const { t } = useTranslation()

  const emptyRowInfo: ReactNode = isError
    ? t('expert_balance_sheet.error.load_failed')
    : t('expert_balance_sheet.empty_state.no_data')

  return (
    <Styled.ExpertBalanceSheetTableWrapper>
      <Table compact>
        <Table.Content maxHeight="none" scrollable>
          <ExpertBalanceSheetTableHeader columns={columns} />
          {isLoading ? (
            <Table.Skeleton columns={columns.length} />
          ) : (
            <ExpertBalanceSheetTableBody
              columns={columns}
              emptyRowInfo={emptyRowInfo}
              isEmpty={isEmpty}
              isError={isError}
              rows={rows}
            />
          )}
        </Table.Content>
      </Table>
    </Styled.ExpertBalanceSheetTableWrapper>
  )
}
